<template>
  <div class="memberDetailsPage">
    <!-- header start -->
    <van-nav-bar
      title="开通会员"
      class="mynavbar"
      left-arrow
      @click-left="onClickLeft"
      :border="false"
    />
    <!-- header end -->

    <div class="tab-panel">
      <div
        class="tab-item"
        v-for="(tab,index) in tabs"
        :key="index"
        :class="{active:num==index}"
        @click="table(index)"
      >{{tab}}</div>
    </div>

    <div v-for="(data,index) in dataList" :key="index" v-show="num==index">
      <router-link :to="'/MemberBuy?id='+data.DistributionLevelId" class="card-box">
        <img :src="data.CoverPhoto" alt class="card-pic" />
      </router-link>

      <div
        v-for="(item,index) in data.IDistributionLevelGroupList.filter(x=>x.ParentId==0)"
        :key="index"
      >
        <memberLevel_panel
          :isProduct="(item.IsProduct==null?false:item.IsProduct)"
          :title="item.Name"
          :modelData="GetChildItems(data,item.Id)"
        ></memberLevel_panel>
      </div>
    </div>

  </div>
</template>

<script>
import memberLevel_panel from "@/components/memberLevel_panel";
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      tabs: [],
      dataList: [],
      num: 0,
      isFirstEnter:false 
    };
  },
  computed:{
    ...mapState({
      VDistributionLevel: state => state.distributionLevel.VDistributionLevel
    }),
  },
  components: {
    memberLevel_panel
  },
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
      //this.init();
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    init() {
      // console.log("init..........");
      var that = this;
      var params = {
        type: "DistributionLevelSearch"
      };
      that.tabs=[];
      if(that.VDistributionLevel==null){
        that.$store.dispatch(params).then(
          res => {
            //console.log(res);
            that.dataList = res.DistributionLevelApiModelList;
            res.DistributionLevelApiModelList.forEach(element => {
              //console.log(element.DistributionLevelName);
              that.tabs.push(element.DistributionLevelName);
            });
          },
          error => {}
        );
      }
      else{
        that.dataList=that.VDistributionLevel.DistributionLevelApiModelList;
        that.VDistributionLevel.DistributionLevelApiModelList.forEach(element => {
              //console.log(element.DistributionLevelName);
              that.tabs.push(element.DistributionLevelName);
        })
      }
      // console.log(that.tabs);
    },
    GetChildItems(data, id) {
      return data.IDistributionLevelGroupList.filter(x => x.ParentId == id);
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    table(index) {
      this.num = index;
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log(from);
    if(from.name=="MProductList")
    {
        to.meta.isBack=true;
    }
    next();
  },
  beforeRouteLeave(to, from, next)
  {
      next();
  },
  activated(){
    console.log("activated");
    console.log(this.$route.meta.isBack+"___"+this.isFirstEnter);
      if(!this.$route.meta.isBack || this.isFirstEnter){
       this.init();
     }
     this.$route.meta.isBack=false;
     this.isFirstEnter=false;
  },
  created(){
    this.isFirstEnter=true;
  }

};
</script>

<style scoped>
.memberDetailsPage {
  background: url("~@/assets/images/me/vip-bg.jpg") top center no-repeat;
  background-size: 100% auto;
}
.mynavbar {
  background: transparent !important;
}
.tab-panel {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  display: flex;
}
.tab-item {
  font-size: 15px;
  color: #444;
  display: inline-block;
  padding: 4px 0;
  flex-shrink: 0;
  border-bottom: 2px solid transparent;
  text-align: center;
  margin-left: 20px;
  margin-right: 15px;
}
.tab-item.active {
  color: #fff;
  border-color: #fff;
}
.card-box {
  margin: 20px 30px;
  display: block;
}
.card-pic {
  border-radius: 12px;
  display: block;
  width: 100%;
}
.block-panel {
  background: #fff;
  margin-bottom: 8px;
}
.block-title {
  font-size: 16px;
  color: #666;
  padding: 15px 15px 6px;
}
.right-ul {
  overflow: hidden;
}
.right-ul .item {
  width: 33.3333333333%;
  padding: 15px;
  display: inline-block;
  vertical-align: top;
}
.right-ul .item .icon {
  width: 34px;
  height: 34px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}
.right-ul .item .tit {
  font-size: 13px;
  color: #444;
  text-align: center;
  margin-top: 8px;
  line-height: 1.4;
}
.goods-list {
  display: flex;
  align-items: center;
  padding: 15px;
}
.goods-list > .hd {
  width: 105px;
  height: 105px;
  margin-right: 14px;
}
.goods-list > .bd {
  flex: 1;
  overflow: hidden;
}
.goods-list > .bd .title {
  overflow: hidden;
  font-size: 14px;
  color: #444;
  line-height: 1.4;
  margin-bottom: 8px;
}
</style>
